import React from 'react';

export default class ResultsSummaryCard extends React.Component {
  render() {
    return (
      <div className='card-container'>
        <div className='card-item' >
          <header
            id='large-left-header'

          >264 Bikes</header>
          <div className='card-content' id='results-card'>
            <div className='summary-card' >
              40X20 sq ft
            </div>
            <div className='summary-card'>
              <div>Double Dockers</div>
              <div>Offset Vertical Racks</div>
              <div>Varsities</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Results/ResultsSummaryCard/index.js